// The source-classification half of Namat/mobile/src/lib/health/healthImportModel.ts,
// duplicated verbatim in the same way healthImportIds.ts and stepsTarget.ts are.
// The window/existence-range helpers are deliberately NOT copied: only the phone
// runs an import pass. What web needs is to READ a stored `source` the same way
// the phone does, so one document does not classify differently in the two apps.
/**
 * What an entry's origin is.
 *
 * Pure: no Firebase, no clock.
 */

export type HealthPlatform = 'ios' | 'android';

/** Mirrors competitionsLogs' `source: 'manual'`, which is the precedent here. */
export type EntrySource = 'manual' | 'health';

export const MANUAL: EntrySource = 'manual';
export const HEALTH: EntrySource = 'health';

/**
 * Anything that is not exactly 'health' is the user's own entry.
 *
 * Deliberately biased: entries written before this feature carry no `source`
 * at all, and misreading one of those as imported would let the importer
 * consider it its own — to skip, to tombstone, to badge. Unknown means manual,
 * always.
 *
 * It also stops the declared `source?: 'manual' | 'health'` from lying: without
 * this, any unexpected stored value reaches the UI unchanged while the type
 * insists it cannot exist.
 */
export function entrySource(raw: unknown): EntrySource {
  return raw === HEALTH ? HEALTH : MANUAL;
}

export function isImported(raw: unknown): boolean {
  return entrySource(raw) === HEALTH;
}
